module.exports = __webpack_public_path__ + "img/landing-step1.a1d13c56.svg";